@if (shouldShowCard()) {
  <div class="card">
    <div class="card-header">
      <h3>{{ 'header_pages_not_scanned' | translate }}</h3>
    </div>
    <div class="card-body">
      <!-- Skipped and broken links -->
      @if (skippedAndBrokenRawData?.length > 0) {
        <div class="row" id="skipped_pages">
          <div class="col-auto flex-grow-1 text-black d-flex align-items-center">
            {{ 'subtitle_scan_results_skipped_pages' | translate }}
          </div>
          <div class="col-auto">
            <span class="text-black me-3" id="skippedEntriesPerPage">{{ 'label_rows_per_page' | translate }}</span>
            <select [(ngModel)]="skippedEntriesPerPage" aria-labelledby="skippedEntriesPerPage">
              @for (limit of entriesLimits; track $index) {
                <option [ngValue]="limit">
                  {{ limit }}
                </option>
              }
            </select>
          </div>
          <div class="col-auto d-flex align-items-center">
            <span class="me-3 text-black">{{
              getPaginationLabel(skippedAndBrokenPage, skippedEntriesPerPage, skippedAndBrokenRawData.length)
            }}</span>
            <ngb-pagination
              class="d-flex align-items-center"
              [attr.aria-label]="'label_skipped_pages_pagination' | translate"
              [(page)]="skippedAndBrokenPage"
              [pageSize]="skippedEntriesPerPage"
              [collectionSize]="skippedAndBrokenTableData.length"
            >
              <ng-template ngbPaginationPrevious>{{ 'label_previous' | translate }}</ng-template>
              <ng-template ngbPaginationNext>{{ 'label_next' | translate }}</ng-template>
              <ng-template ngbPaginationNumber let-pageNum>
                <span class="visually-hidden">
                  {{ (pageNum !== skippedAndBrokenPage ? 'go_to_page' : 'page') | translate }}
                  &nbsp;
                </span>
                {{ pageNum }}
              </ng-template>
            </ngb-pagination>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12">
            <app-ngb-table
              [config]="getTableConfig('table_caption_skipped_and_broken_links')"
              [data]="
                skippedAndBrokenTableData
                  | slice: (skippedAndBrokenPage - 1) * skippedEntriesPerPage : skippedAndBrokenPage * skippedEntriesPerPage
              "
            >
            </app-ngb-table>
          </div>
        </div>
        <div class="row mb-5">
          <div class="col-12 d-flex justify-content-end align-items-center">
            <span class="me-3 text-black">{{
              getPaginationLabel(skippedAndBrokenPage, skippedEntriesPerPage, skippedAndBrokenRawData.length)
            }}</span>
            <ngb-pagination
              class="d-flex align-items-center"
              [attr.aria-label]="'label_skipped_pages_pagination' | translate"
              [(page)]="skippedAndBrokenPage"
              [pageSize]="skippedEntriesPerPage"
              [collectionSize]="skippedAndBrokenTableData.length"
            >
              <ng-template ngbPaginationPrevious>{{ 'label_previous' | translate }}</ng-template>
              <ng-template ngbPaginationNext>{{ 'label_next' | translate }}</ng-template>
              <ng-template ngbPaginationNumber let-pageNum>
                <span class="visually-hidden">
                  {{ (pageNum !== skippedAndBrokenPage ? 'go_to_page' : 'page') | translate }}
                  &nbsp;
                </span>
                {{ pageNum }}
              </ng-template>
            </ngb-pagination>
          </div>
        </div>
      }
      <!-- Pages with errors -->
      @if (errorsRawData?.length > 0) {
        <div class="row">
          <div class="col-auto flex-grow-1 text-black d-flex align-items-center">
            {{ 'subtitle_scan_results_error_pages' | translate }}
          </div>
          <div class="col-auto">
            <span class="text-black me-3" id="errorsEntriesPerPage">{{ 'label_rows_per_page' | translate }}</span>
            <select [(ngModel)]="errorsEntriesPerPage" (ngModelChange)="getErrors.next()" aria-labelledby="errorsEntriesPerPage">
              @for (limit of entriesLimits; track $index) {
                <option [ngValue]="limit">
                  {{ limit }}
                </option>
              }
            </select>
          </div>
          <div class="col-auto d-flex align-items-center">
            <span class="me-3 text-black">{{ getPaginationLabel(errorsPage, errorsEntriesPerPage, totalErrors) }}</span>
            <ngb-pagination
              class="d-flex align-items-center"
              [attr.aria-label]="'label_pages_with_errors_pagination' | translate"
              [(page)]="errorsPage"
              [pageSize]="errorsEntriesPerPage"
              [collectionSize]="totalErrors"
              (pageChange)="getErrors.next()"
            >
              <ng-template ngbPaginationPrevious>{{ 'label_previous' | translate }}</ng-template>
              <ng-template ngbPaginationNext>{{ 'label_next' | translate }}</ng-template>
              <ng-template ngbPaginationNumber let-pageNum>
                <span class="visually-hidden">
                  {{ (pageNum !== errorsPage ? 'go_to_page' : 'page') | translate }}
                  &nbsp;
                </span>
                {{ pageNum }}
              </ng-template>
            </ngb-pagination>
          </div>
        </div>
        <div class="row my-3">
          <div class="col-12">
            <app-ngb-table [config]="getTableConfig('table_caption_pages_with_errors')" [data]="errorsTableData"> </app-ngb-table>
          </div>
        </div>
        <div class="row">
          <div class="col-12 d-flex justify-content-end align-items-center">
            <span class="me-3 text-black">{{ getPaginationLabel(errorsPage, errorsEntriesPerPage, totalErrors) }}</span>
            <ngb-pagination
              class="d-flex align-items-center"
              [attr.aria-label]="'label_pages_with_errors_pagination' | translate"
              [(page)]="errorsPage"
              [pageSize]="errorsEntriesPerPage"
              [collectionSize]="totalErrors"
              (pageChange)="getErrors.next()"
            >
              <ng-template ngbPaginationPrevious>{{ 'label_previous' | translate }}</ng-template>
              <ng-template ngbPaginationNext>{{ 'label_next' | translate }}</ng-template>
              <ng-template ngbPaginationNumber let-pageNum>
                <span class="visually-hidden">
                  {{ (pageNum !== errorsPage ? 'go_to_page' : 'page') | translate }}
                  &nbsp;
                </span>
                {{ pageNum }}
              </ng-template>
            </ngb-pagination>
          </div>
        </div>
      }
    </div>
  </div>
}
